<section class="parallax">
    <div class="caption">
      <span class="border display-5 fw-bold">Banda Island</span>
      <p>
        Banda Islands, an Indonesian paradise, offer rich history, pristine beaches, and vibrant marine life. Known for historical significance, these remote islands boast stunning coral reefs, perfect for diving, and Nutmeg plantations, inviting travelers to explore their natural beauty and cultural heritage.
      </p>
    </div>
</section>
<div class="d-none d-md-block">
    <div class="container-fluid py-5">
        <div class="text-center py-5" *ngIf="loading">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <!-- Error Alert -->
        <div class="alert alert-danger" *ngIf="error" role="alert">
            {{ error }}
        </div>



            <!-- Main Gallery Grid -->
    <div class="row g-4" *ngIf="!loading && !error">
        <!-- Large left image -->
        <div class="col-md-4">
          <div class="row g-3">
            <!-- First small image -->
            <div class="col-12" *ngIf="displayedImages[0]">
              <div class="card border-0 shadow gallery-card">
                <div class="card-img-wrapper">
                  <div class="img-overlay">
                    <!-- <div class="overlay-content">
                      <h5 class="text-white">{{ displayedImages[0].boat_name }}</h5>
                      <p class="text-white mb-0">{{ displayedImages[0].boat_kategori }}</p>
                    </div> -->
                  </div>
                  <img [src]="getImageUrl(displayedImages[0])" 
                       class="gallery-img" 
                       [alt]="displayedImages[0]">
                </div>
              </div>
            </div>
    
            <!-- Second small image -->
            <div class="col-12" *ngIf="displayedImages[1]">
              <div class="card border-0 shadow gallery-card">
                <div class="card-img-wrapper">
                  <div class="img-overlay">
                    <!-- <div class="overlay-content">
                      <h5 class="text-white">{{ displayedImages[1].boat_name }}</h5>
                      <p class="text-white mb-0">{{ displayedImages[1].boat_kategori }}</p>
                    </div> -->
                  </div>
                  <img [src]="getImageUrl(displayedImages[1])" 
                       class="gallery-img" 
                       [alt]="displayedImages[1]">
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <!-- Large middle image -->
        <div class="col-md-4" *ngIf="displayedImages[2]">
          <div class="card h-100 border-0 shadow gallery-card">
            <div class="position-relative main-image-container">
              <div class="img-overlay">
                <!-- <div class="overlay-content">
                  <h5 class="text-white">{{ displayedImages[2].boat_name }}</h5>
                  <p class="text-white mb-0">{{ displayedImages[2].boat_kategori }}</p>
                </div> -->
              </div>
              <img [src]="getImageUrl(displayedImages[2])" 
                   class="img-fluid w-100 rounded shadow main-image" 
                   [alt]="displayedImages[2]">
            </div>
          </div>
        </div>
    
        <!-- Right column with smaller images -->
        <div class="col-md-4">
          <div class="row g-3">
            <!-- First small image -->
            <div class="col-12" *ngIf="displayedImages[3]">
              <div class="card border-0 shadow gallery-card">
                <div class="card-img-wrapper">
                  <div class="img-overlay">
                    <!-- <div class="overlay-content">
                      <h5 class="text-white">{{ displayedImages[3].boat_name }}</h5>
                      <p class="text-white mb-0">{{ displayedImages[3].boat_kategori }}</p>
                    </div> -->
                  </div>
                  <img [src]="getImageUrl(displayedImages[3])" 
                       class="gallery-img" 
                       [alt]="displayedImages[3]">
                </div>
              </div>
            </div>
    
            <!-- Second small image -->
            <div class="col-12">
    
              <div class="row g-3">
                <div class="col-6" *ngIf="displayedImages[4]">
                  <div class="card h-100 border-0 shadow gallery-card">
                    <div class="card-img-wrapper2">
                      <div class="img-overlay">
                        <!-- <div class="overlay-content">
                          <h5 class="text-white">{{ displayedImages[4].boat_name }}</h5>
                          <p class="text-white mb-0">{{ displayedImages[4].boat_kategori }}</p>
                        </div> -->
                      </div>
                      <img [src]="getImageUrl(displayedImages[4])" 
                           class="gallery-img" 
                           [alt]="displayedImages[4]">
                    </div>
                  </div>
                </div>
    
    
                <div class="col-6" *ngIf="displayedImages[5]">
                  <div class="card h-100 border-0 shadow gallery-card">
                    <div class="card-img-wrapper2">
                      <div class="img-overlay">
                        <!-- <div class="overlay-content">
                          <h5 class="text-white">{{ displayedImages[5].boat_name }}</h5>
                          <p class="text-white mb-0">{{ displayedImages[5].boat_kategori }}</p>
                        </div> -->
                      </div>
                      <img [src]="getImageUrl(displayedImages[5])" 
                           class="gallery-img" 
                           [alt]="displayedImages[5]">
                    </div>
                  </div>
                </div>
              </div>
    
    
       
            </div>
          </div>
        </div>
      </div>

    </div>
</div>


<div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="px-4  my-3 text-center">
            <h1 class="display-5 fw-bold mt-4 mb-4">Banda Island</h1>
        </div>
      </div>
     
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="subjudul">
                <h5>An exotic medley of cultures</h5>
            </div>
    
            <p style="text-align: justify;">Banda Islands, situated in Indonesia, boast a rich cultural heritage. Renowned for their historical significance in the spice trade, these islands are steeped in diverse cultural influences. The local community showcases a unique fusion of traditions shaped by indigenous cultures, colonial histories, and global exchanges. The vibrant cultural tapestry includes traditional dances, music, culinary delights, and craftsmanship, reflecting a blend of Indonesian, European, and indigenous customs, making Banda Islands a melting pot of cultural diversity.</p>
        </div>

        <div class="col-md-6">
            <div class="subjudul">
                <h5>Reason to visit</h5>
            </div>
    
            <p style="text-align: justify;">Visiting Banda Islands offers a one-of-a-kind travel experience. The archipelago’s historical significance, stunning natural beauty, and cultural richness make it a must-see destination. Its historical value in the spice trade, coupled with pristine beaches, excellent diving spots, and lush landscapes, entices adventurers and history enthusiasts alike. The local culture, a blend of diverse influences, provides a unique insight into Indonesia’s heritage. Banda Islands promise an immersive journey, combining history, natural wonders, and cultural exploration in a picturesque setting.</p>
        </div>
    </div>


      <!-- Boats List Section -->
      <div class="row text-center mb-3 mt-5">
        <div class="col-md-4" *ngFor="let boat of displayedBoats">
          <div class="card mb-4 box-shadow">
            <div class="position-relative">
              <ng-container *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 0">
              <span class="badge bg-success position-absolute top-0 start-0 m-2"  *ngIf="boat.featured">
                FEATURED
              </span>
              <span class="badge bg-secondary position-absolute top-0 end-0 m-2" style="z-index: 10;">
                {{boat.boat_kategori}}
              </span>
            </ng-container>
  
              <!-- Carousel -->
              <div [id]="'carouselExample-' + boat.id" class="carousel slide">
                <div class="carousel-inner" (click)="navigateToDetail(boat.slug)" style="cursor: pointer;">
                  <div 
                    class="carousel-item" 
                    *ngFor="let image of boat.ms_gambarkapals; let i = index" 
                    [ngClass]="{'active': i === 0}"
                  >
                    <img [src]="getBoatImage(image)"
                    class="d-block w-100"
                    [alt]="boat.nama_kapal"
                    loading="lazy"
                    >
                  </div>
                </div>
                <button *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 1"  class="carousel-control-prev" type="button" [attr.data-bs-target]="'#carouselExample-' + boat.id" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 1" class="carousel-control-next" type="button" [attr.data-bs-target]="'#carouselExample-' + boat.id" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
  
                <div class="position-absolute bottom-0 start-0 p-3" *ngIf="boat?.ms_gambarkapals && boat.ms_gambarkapals.length > 0">
                  <h5 class="card-title text-white">
                    {{ boat.durasi }}
                    <span class="hrg">IDR {{ boat.harga_display | number }}</span>
                  </h5>
                  <p class="text-white mb-0">IDR {{ boat.harga | number }}/Pax</p>
                </div>
              </div>
            </div>
  
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h5 (click)="navigateToDetail(boat.slug)" class="card-subtitle" style="cursor: pointer;">{{ boat.nama_kapal }}</h5>
                
        
            
              </div>
  
              <div class="d-flex text-center mb-2">
                <div class="ket me-3">
                  <i class="fa fa-bed"></i> {{ boat.kabin }} Cabins
                </div>
                <div class="ket">
                  <i class="fa fa-users"></i> {{ boat.jumlah_tamu }} Guests
                </div>
              </div>
  
              <p class="mb-0">{{ boat.trip_kategori }}</p>
            </div>
          </div>
        </div>
      </div>
  
    <!-- Load More Button -->
    <div class="row mb-4" *ngIf="displayedBoats.length < filteredBoats.length">
      <div class="col-12 text-center">
        <button class="btn btn-outline-primary" (click)="loadMore()">Load More</button>
      </div>
    </div>
</div>

<app-review></app-review>
<app-review-b></app-review-b>
<app-footer></app-footer>
